import { render, staticRenderFns } from "./StoreInfos.vue?vue&type=template&id=fafe8762&"
import script from "./StoreInfos.vue?vue&type=script&lang=js&"
export * from "./StoreInfos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports